/* eslint-disable no-loop-func */
/* eslint-disable @typescript-eslint/no-loop-func */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
// Utils
import { useSetState, validArray, getOrganisationName } from 'utils';
import { setOrganisations } from 'utils/user';
// App Context
import { useAppDispatch } from 'context/AppContext';
import { postDispatcherTrigger } from 'context/AppContext/middleware';
// Auth Context
import { useAuthState } from 'context/AuthContext';
// Elements
import Alert from 'elements/Alert';
import Button from 'elements/Button';
import ToggleItem from 'elements/ListItems/components/ToggleItem';
import SelectMulti from 'elements/Forms/components/SelectMulti';
import { Loading } from 'elements/Loading';
// Components
import PageHeader from 'components/PageHeader';
// Config
import SupplierId from './config';
// Style
import styles from './style/dispatcher.module.css';

function Dispatcher() {
  const history = useHistory();
  const appDispatch = useAppDispatch();
  // const { appState } = useAppState();
  // Auth State
  const { defaultOrganisation: { orgRef } } = useAuthState();
  // State
  const initialState = {
    error: '',
    loading: false,
    creates: false,
    updates: false,
    organisation: [],
    supplierIds: [],
  }
  const [state, setState] = useSetState(initialState);

  function getSupplierId(name: string) {
    let id = null;
    for (const [key, items] of Object.entries(SupplierId)) {
      if (orgRef === key) {
        items.forEach((item: { displayName: string, supplierId: string }) => {
          if (name === item.displayName) {
            id = item.supplierId
          }
        });
      }       
    }
    return id;
  }

  async function handleSubmit() {
    if (state.supplierIds.length === 0) {
      setState({
        error: 'Please select atleast one of the Supplier Id',
      });
      return;
    }
    if (state.creates === false && state.updates === false) {
      setState({
        error: 'Please select atleast one of the action',
      });
      return;
    }
    setState({
      loading: true,
      error: '',
    });
    await postDispatcherTrigger({
      dispatch: appDispatch,
      supplierId: state.supplierIds.map((i: { orgDescription: string; }) => getSupplierId(i.orgDescription)),
      creates: state.creates,
      updates: state.updates,
    });

    /* if (appState === 'GET_DISPATCHER_TRIGGER_SUCCESS') {
      appDispatch(addNotification({
        label: 'Dispatcher Triggered Successfully',
        type: 'success',
      }));
      setState(initialState);
    }
      
    if (appState === 'GET_DISPATCHER_TRIGGER_ERROR') {
      appDispatch(addNotification({
        label: 'Could Not Process Dispatcher Action Request, Please Check You Have Entered a Valid Details.',
        type: 'error',
      }))
    } */
    setState(initialState);
  }

  async function fetchOrganisation() {
    for (const [key, item] of Object.entries(SupplierId)) {
      if (orgRef === key) {
        setState({
          organisation: item.map((i: { displayName: string }) => i.displayName),
        });
      }       
    }
  }

  useEffect(() => {
    fetchOrganisation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.supplierIds]);

  return (
    <>
      <PageHeader heading="Sales Order Processing" customHeight={166} />
      <section className="wrapper">
        <div className="wrapper__content">
          <div className={styles.container}>
            <Alert
              active={state.error}
              label={state.error}
              type="error"
            />
            <div className={styles.grid}>
              <SelectMulti
                handleOnChange={(e:{ target: HTMLInputElement }) => setState({
                  supplierIds: setOrganisations({ orgDescription: e.target.value }, state.supplierIds),
                })}
                items={state.organisation}
                label="Supplier Organisation ID"
                name="supplier-id"
                value={(validArray(state.supplierIds) && state.supplierIds.map(getOrganisationName).join(', ')) || ''}
              />
              <div className={styles.innergrid}>
                <ToggleItem
                  checked={state.creates}
                  name="creates"
                  handler={() => setState({
                    creates: !state.creates,
                  })}
                  label="Send New Sales Order"
                  value="Send New Sales Order"
                />
                <ToggleItem
                  checked={state.updates}
                  name="updates"
                  handler={() => setState({
                    updates: !state.updates,
                  })}
                  label="Process Amend Sales Order"
                  value="Process Amend Sales Order"
                />
              </div>
              <div className={styles.actions}>
                <Button btnStyle="light" handler={() => history.goBack()}>
                  Cancel
                </Button>
                { state.loading ? (
                  <Button btnStyle="secondary" btnType="icon">
                    <Loading fill="white" size={32} />
                  </Button>
                ) : (
                  <Button
                    btnStyle="secondary"
                    disabled={state.loading}
                    handler={() => handleSubmit()}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Dispatcher;
